import React from 'react';
import classNames from 'classnames';
import history from 'src/navigation/history';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import CaseEnum from '../../../../../../../enumerables/case-enum';
import { getValFromEnum } from '../../../../../../../components/redux-form/utils/dropdown-values';

const CreatePaymentButton: React.FunctionComponent = () => {
    const handlePay = (caseType: SelectObject) => {
        history.push(Router.generate(routes.PAYMENT_CREATE), { caseType });
    };
    const typeEnum = CaseEnum ? CaseEnum.getEnum('caseType') : {};
    const caseTypes: SelectObject[] = getValFromEnum(typeEnum);

    return (
        <div className={classNames('text-right w-100')}>
            <DropdownButton id="dropdown-basic-button" title="Create">
                {caseTypes.map((it, i: number) => (
                    <Dropdown.Item key={`${i}-`} onClick={() => handlePay(it)}>
                        {it.label}
                    </Dropdown.Item>
                ))}
            </DropdownButton>
        </div>
    );
};

export default CreatePaymentButton;
